import { render } from "./AdvertisingBanner.vue?vue&type=template&id=4015a7c6"
import script from "./AdvertisingBanner.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdvertisingBanner.vue?vue&type=script&charset=utf-8&lang=js"

import "./AdvertisingBanner.vue?vue&type=style&index=0&id=4015a7c6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__